 
 
//export const base_url = 'http://localhost:3000/';
export const base_url = 'http://klothfashionstore.com/'; 
export const api_base_url = 'http://klothfashionstore.com/klothadmin/public/api/';
export const web_base_url = 'http://klothfashionstore.com/';
export const Stripe_Code = 'pk_live_51K43lbAZIazeKeR5chCX10JupWThzB4HTCBRQjURqB5Y3vl36CSdzb1txP05pdYHuGt9U2y1eknrSSi2ZFUIQ2vE00OBBAThp7';
//export const Stripe_Code = 'pk_test_51K43lbAZIazeKeR57OxqrC1TrWC7JXQFKRApcwN00KQL0NMo86jNJBRoch7W09PfLD3iw3jMNuW8UhDQ6kAN7Ekv00oUZ63CPk';